/**
 * Add padding/margin to elements whenn a modal gets opened (and scrollbar gets
 * removed).
 */
export default class ModalOpenPositionFix {
	constructor() {
		const modalObserver = new MutationObserver( () => {
			const elements = document.querySelectorAll(
				'.modal-open-fix--add-margin, .modal-open-fix--add-padding' );
			for ( const element of elements ) {
				const styleProperty = element.classList.contains( 'modal-open-fix--add-margin' )
							? 'marginRight' : 'paddingRight';
				if ( document.body.classList.contains( 'modal-open' ) ) {
					element.style[styleProperty] = document.body.style.paddingRight;
					console.log('set', element);
				} else {
					element.style[styleProperty] = null;
				}
			}
		} );
		modalObserver.observe( document.body, { attributeFilter: [ 'class' ] } );
	};
};
